export function mediaInfoTestimonials() {
    let $slider = $(".media-info-testimonials");

    function sliderInit() {
        $slider.slick({
            arrows: false,
            slidesToShow: 1,
            mobileFirst: true,
            dots: true,
            adaptiveHeight: true,
            fade: true
        }).on("beforeChange", function (event, slick, currentSlide,  nextSlide){
            const sliders = slick.$slides;
            const srcPicture = $(sliders[nextSlide]).find(".item").data("photo");
            const pictureBox = $(this).closest(".media-info-section").find(".photo-holder");

            if (srcPicture) {
                const sliderPicture = $(pictureBox).find("img");
                const clonePicture = $(sliderPicture).clone().attr("src", srcPicture);
                clonePicture.insertBefore($(pictureBox).find("img"));
                sliderPicture.addClass("fade");
                setTimeout(function (){
                    sliderPicture.remove();
                }, 200);


                // $(pictureBox).addClass("fade");
                // $(pictureBox).find("img").attr("src", srcPicture);
                // $(pictureBox).removeClass("fade");
            }
        });
    }

    sliderInit();
}


// WEBPACK FOOTER //
// ./assets/js/modules/mediaInfoTestimonials.js